








































































































































































































































































































































































































































import { Component, Emit, Model, Prop, Ref, Watch } from "vue-property-decorator";
import Vue from "vue";
import VueSlider from 'vue-slider-component'
import PresetScoringKeys from "@/utils/PresetScoringKeys";
import _ from "lodash";
import * as rules from '@/rules';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';

@Component({
    components: {VueSlider, ConfirmationDialog, DescriptionEditor}
})
export default class ScoringKeyCreator extends Vue {

    private PRESET_SCORING_KEYS = PresetScoringKeys.PRESET_SCORING_KEYS;

    @Model("update:scoringKeys")
    private scoringKeys!: any[];

    @Prop()
    scoringRules!: any[];

    $refs!: {
        keyForm: HTMLFormElement;
    };

    private binValues: number[] = []

    private endSliderOptions = [];
    private redrawInc = 0;
    private maxUpperLimit: number = 1
    private minLowerLimit: number = 0
    private tempUpperLimit: number = 1;
    private tempLowerLimit: number = 0;
    private tempName = "";
    private tempDescription = "";
    private showEditMenu= {};
    private style = {backgroundColor: 'red'}
    private valid = true;
    private updateSliderOptions() {
        let arr = []
        this.endSliderOptions = []
        if(this.binValues.length === 1){
            arr.push({disabled: true,})
            this.endSliderOptions = arr;
            return;

        }
        for(let i = 0; i < this.binValues.length; i++) {
            if(i=== 0) {
                arr.push({disabled: false,})

            }
            else if(i === this.binValues.length-1) {
                arr.push({disabled: true,})
            }
            else
                arr.push({disabled: false,})
        }        
        this.endSliderOptions = arr;
    }

    // private process = val=> {
    //     let arr = []
    //     if(this.scoringKeys.length === 1){
    //         arr.push([0,100])
    //     }
    //     else {
    //         for(let i = this.scoringKeys.length-1; i > 0; i--) {
    //             if(i === this.scoringKeys.length-1) {
    //                 arr.push([val[i-1], 100])
    //             }
    //             else
    //                 arr.push([val[i-1], val[i]])
    //         }
    //         arr.push([0, val[0]])
    //     }
    //     console.log(this.binValues, this.scoringKeys)
    //     return arr;
    // }

       private process = val=> {
        let arr = []
        let valArr = Object.values(val)
        
        arr.push([0, valArr[0]])
        if(valArr.length <=1) {
            return arr
        }
            for(let i = 0; i < valArr.length-1; i++) {
                arr.splice(0,0, [valArr[i+1], valArr[i]])
            }
           // arr.push([0, val[0]])
        
        return arr;
    }
    
    
    private marks = (val: number) => val % 0.25 === 0 ? ({label: `${val * 100}%`}) : false;
    private selectedBin:number = -1;
    private headers =
        [
            {
                text: 'Actions',
                value:'actions',
                width: '120px'
            },
            {
                text: 'Name',
                value: 'name',
                width: '150px'
            },
            {
                text: 'Lower Limit Exclusive',
                value: 'lowerLimitExclusive',
                width: '150px'
            },
            {
                text: 'Upper Limit Inclusive',
                value: 'upperLimit',
                width: '150px'
            },
            {
                text: 'Description',
                value: 'description'
            },
        ]
    

    mounted() {
        if (this.scoringKeys.length > 0) {
            this.sliderValuesFromKeys();
        }
    }

    @Emit("changed")
    private addScoringKey() {
        let scoringKey;
        let sliderValue;
        let upperBinValue
        let lowerBinValue
        if (this.scoringKeys.length === 0) {
            scoringKey = {
                name: "Key " + (this.scoringKeys.length + 1),
                description: "",
                upperLimit: 1.0
            }
            upperBinValue = 1
            lowerBinValue = 0

        } else {
            let upperLimit = this.scoringKeys
                .map(k => k.upperLimit)
                .filter(v => v != null)
                .reduce((a, b) => Math.min(a, b)) / 2.0

            scoringKey = {
                name: "Key " + (this.scoringKeys.length + 1),
                description: "",
                upperLimit: upperLimit
            }
            upperBinValue = upperLimit
            Vue.set(this.scoringKeys[this.scoringKeys.length - 1], "lowerLimitExclusive", upperLimit);
        }
        this.binValues.splice(0, 0, upperBinValue)
        this.checkBinValues();
        this.scoringKeys.splice(this.scoringKeys.length, 0, scoringKey)
        this.updateScoringKeys();
        this.updateSliderOptions()
        this.$emit('changed')
    }

    @Emit("changed")
    private removeScoringKey(scoringKey: any) {
        // if (index === 0 && this.scoringKeys.length === 1) {

        // } else if (index === 0) {
        //     this.sliderValues[index + 1].splice(1, 1, this.sliderValues[index][1]);
        //     this.binValues.splice(index, 1);
        // } else {
        //     this.sliderValues[index - 1].splice(0, 1, this.sliderValues[index][0]);
        //     this.binValues.splice(index, 1);
        // }
        let index = this.binValues.indexOf(scoringKey.upperLimit)
        let scoringKeyIndex = this.scoringKeys.findIndex((key: any)=> _.isEqual(scoringKey, key))

        if (scoringKeyIndex === 0) {
            index = this.binValues.indexOf(scoringKey.lowerLimitExclusive)
        }

        if(scoringKeyIndex === this.scoringKeys.length - 1){
            index = this.binValues.indexOf(scoringKey.upperLimit)
            this.binValues[index+1] = 0
        }
        this.scoringKeys.splice(scoringKeyIndex, 1);

        this.binValues.splice(index, 1)
        this.updateScoringKeys();
        this.$emit('changed')
    }

    // private updateSliderValue(value: any, sliderIndex: number) {
    //     if (value[1] > this.sliderValues[sliderIndex - 1][1]) {
    //         this.sliderValues[sliderIndex].splice(1, 1, this.sliderValues[sliderIndex - 1][1] - 0.01)
    //         this.sliderValues[sliderIndex - 1].splice(0, 1, this.sliderValues[sliderIndex - 1][1] - 0.01)
    //     } else {
    //         this.sliderValues[sliderIndex].splice(1, 1, value[1])
    //         this.sliderValues[sliderIndex - 1].splice(0, 1, value[1])
    //     }

    // }

    private checkBinValues() {
        if(this.binValues.length >= 3){
            if(this.binValues.length >= 3 && (Math.abs(this.binValues[0] - this.binValues[1]) < 0.05)) {
                this.binValues[1]= (this.binValues[0] + this.binValues[2])/2;
            }
        }
    }

    //Updates scoring keys from the slider values
    private updateScoringKeys() {
        let sortedBins = _.cloneDeep(this.binValues).sort((a, b) => b - a)
        for (let index = 0 ; index < this.scoringKeys.length; index++) {
            Vue.set(this.scoringKeys[index], 'upperLimit', sortedBins[index]);
    
            if (index !== this.scoringKeys.length - 1) {
                Vue.set(this.scoringKeys[index], 'lowerLimitExclusive', sortedBins[index + 1]);
                (index === 0) ?  this.endSliderOptions.push({disabled: true,}): this.endSliderOptions.push({disabled: false,})

            } else {
                Vue.set(this.scoringKeys[index], 'lowerLimitExclusive', null);

            }
        }
        this.updateSliderOptions()
    }

    // Select an existing set of scoring keys, such as copy from other factor
    private selectExisting(scoringKeys: any) {
        while (this.scoringKeys.length !== 0) {
            this.scoringKeys.splice(0, 1)
        }
        for (let index in scoringKeys) {
            this.scoringKeys.splice(this.scoringKeys.length, 0, scoringKeys[index]);
        }
        this.sliderValuesFromKeys();
    }

    // Select a predefined templates
    private selectPredefined(predefinedScoringKey: any) {
        if (!predefinedScoringKey) return;
        let scoringKeys = Object.assign(_.cloneDeep(predefinedScoringKey.scoringKeys));
        this.selectExisting(scoringKeys);
    }

    //Clears the scoring keys and slider values, basically a reset
    @Emit("changed")
    private clear() {
        while (this.scoringKeys.length !== 0) {
            this.scoringKeys.splice(0, 1)
        }
        this.binValues = []
        this.endSliderOptions = []
        this.$emit('changed')

    }

    //Create slider values from keys
    private sliderValuesFromKeys() {
        let sliderValues = [];
        let newSlideValues = []
        this.endSliderOptions = []
        this.scoringKeys = this.scoringKeys.sort((a, b) => b.upperLimit - a.upperLimit)
        for (let index = 0; index < this.scoringKeys.length; index++) {
            let sliderValue;

            if (index === this.scoringKeys.length - 1) {
                sliderValue = [0, this.scoringKeys[index].upperLimit];
                newSlideValues.push(this.scoringKeys[index].upperLimit)
                if(this.scoringKeys[index].upperLimit != 0){
                    newSlideValues.push(0)
                }

                this.endSliderOptions.push({disabled: true,})
            } else {
                sliderValue = [this.scoringKeys[index + 1].upperLimit, this.scoringKeys[index].upperLimit]
                newSlideValues.push(this.scoringKeys[index].upperLimit)
              this.endSliderOptions.push({disabled: false,})

            }
            sliderValues.push(sliderValue);
        }
        this.binValues = newSlideValues
        this.binValues = this.binValues.sort()
        this.updateSliderOptions()

    }

    @Watch('scoringKeys', {deep: true})
    private onChangeScoringKeys(newVal, oldVal){
        if(this.redrawInc === 0) {
            this.sliderValuesFromKeys()
        }
        ++this.redrawInc;
    }

    private blurLimits(item: any) {
        console.log(item)
    }

    private fetchScoringKey(item) {
        this.tempLowerLimit = (item.lowerLimitExclusive === undefined) ? 0: item.lowerLimitExclusive
        this.tempUpperLimit = item.upperLimit
        let keyIndex = this.scoringKeys.indexOf((key: any) => _.isEqual(key, item))
        if(item.upperLimit === 1) {
            this.maxUpperLimit = 1;
        } else {
            this.maxUpperLimit = this.binValues[_.indexOf(this.binValues, item.upperLimit) + 1]
        }

        if(item.lowerLimitExclusive === 0 || item.lowerLimitExclusive === undefined || item.lowerLimitExclusive === null) {
            this.minLowerLimit = 0;
        } else {
            this.minLowerLimit =  this.binValues[_.indexOf(this.binValues, item.lowerLimitExclusive) - 1]
        }

        this.tempDescription=item.description
        this.tempName = item.name

    }

    private updateScoringKeyValues(item: any) {
        if(!this.$refs.keyForm.validate()) {
            return
        } 
        this.binValues.splice(_.indexOf(this.binValues, item.upperLimit),1, this.tempUpperLimit)
        if(item.lowerLimitExclusive != null)
            this.binValues.splice(_.indexOf(this.binValues, item.lowerLimitExclusive),1, this.tempLowerLimit)
        this.redrawInc = this.redrawInc + 1;
        Vue.set(item, 'name', this.tempName)
        Vue.set(item, 'description', this.tempDescription)
        this.updateScoringKeys()
        this.showEditMenu[item.name] = false

    }

    private distributeKeys() {
        let newValues = [];
        let index = 0;
        //Go through the range of keys
        for(let val of Array(this.scoringKeys.length).keys()) {
            //The slider doesn't use the 0 index so skip it
            if(val === 0)
                continue;
            newValues[index] = parseFloat((val * (1/this.scoringKeys.length)).toFixed(4))
            index += 1;
        }
        //Need to have upper limit of 1, don't push 1 if there already is 1
        if(newValues[newValues.length-1] != 1)
            newValues.push(1);
        this.binValues = newValues;
        this.updateScoringKeys();
        this.sliderValuesFromKeys();
        //Delete 0 index that gets created in the above functions
        this.binValues.splice(0,1)
        this.endSliderOptions = [];
        //Update slider options - disabled vs enabled slider values
        for(let val = 0; val < this.binValues.length; val++) {
            if(val != this.binValues.length -1) {
                this.endSliderOptions.push({disabled: false});
            } else {
                this.endSliderOptions.push({disabled: true,}) 
            }
        }
       

    }

}
